"use strict";
import request from "@/utils/request";
class CompanyService {
  static search(query) {
    return request({
      url: `company/search-company`,
      method: "get",
      params: query,
    });
  }
  static list(query) {
    return request({
      url: `company/my-list`,
      timeout: 60000,
      method: "get",
      params: query,
    });
  }
  static updateService(data, param) {
    return request({
      url: `company/updateservices/` + param,
      timeout: 60000,
      method: "put",
      data,
    });
  }
  static createService(data) {
    return request({
      url: `company/createservices`,
      timeout: 60000,
      method: "post",
      data,
    });
  }

  static addSubscriptions(data) {
    return request({
      timeout: 60000,
      url: `company/add-subscriptions`,
      method: "post",
      data,
    });
  }
  static getService(query) {
    return request({
      url: `company/listservices`,
      method: "post",
      params: query,
    });
  }

  static createRoute(data) {
    return request({
      url: `company/create-route`,
      method: "post",
      data,
    });
  }
  static addRouteUser(data) {
    return request({
      url: `company/add-route-user`,
      method: "post",
      data,
    });
  }
  static deleteRoute(data) {
    return request({
      url: `company/delete-route`,
      method: "post",
      data,
    });
  }
  static getListRoutes(data) {
    return request({
      url: `company/list-routes`,
      method: "post",
      data,
    });
  }
  static getRoutesUser(data) {
    return request({
      url: `company/list-routes-user`,
      method: "post",
      data,
    });
  }
  static editRouteUser(data) {
    return request({
      url: `company/edit-route-user`,
      method: "post",
      data,
    });
  }
  static confirmSubscriptions(data) {
    return request({
      url: `company/subscriptions-checked`,
      method: "post",
      data,
    });
  }
  static getSingleMarkers(query) {
    return request({
      url: `company/subscriptions`,
      method: "get",
      params: query,
    });
  }
}

export default CompanyService;
